import { TextEditor } from '@components/text-editor';

import { useStore } from 'models/Provider';

export const TextEditorToolbar = () => {
  const { t } = useStore();
  return (
    <TextEditor.Toolbar
      anchorButtonProps={{
        save: t('job.create.description.hyper.link.save'),
        addLink: t('job.create.description.hyper.link.addLink'),
        linkToolTip: t('job.create.description.hyper.link.linkToolTip'),
        label: t('job.create.description.hyper.link.label'),
      }}
    />
  );
};
